export default "__VITE_ASSET__6fcd4fc3__"